/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';
import type { FindFeaturedParams, Featured } from 'types';

const find = async (params: FindFeaturedParams): Promise<Featured[]> => {
  const endpoint = '/protones-portlet.roomitems/find-all';
  const response = await callLiferayEndpoint(endpoint, {});
  // ignoro dati aggiuntivi della risposta e prendo il primo elemento di un array (con un unico elemento)
  const results = response.map(utils.toFeatured);
  return results;
};

const get = async (id: number): Promise<Featured> => {
  const endpoint = '/protones-portlet.roomitems/get';
  const response = await callLiferayEndpoint(endpoint, { id });
  return utils.toFeatured(response);
};

export default {
  find,
  get,
};
